export default __webpack_public_path__ + "static/media/kitchen5-beforeA-2048w.92328472.avif";